const Reload = {
  name:'Reload',
  abstract: true,
  props:['condition'],
  data(){
    return {
      flag:false
    }
  },
  created(){
    this.$watch('condition' , function(){
      this.flag = true
    })
  },
  render(){
    if( this.flag ) {
      this.flag = false
      return null
    }else{
      return this.$slots.default
    }
  }
}

export default Reload